import React from 'react';
import { Image } from '../Image';
import { centsToDollarsNumber } from '../../lib/util';
import styles from '../../styles/lineItem.module.scss';
import { CartItemID, GiftCardDelivery } from '../../types';
import { GIFT_CARD_CART_IMAGE } from '../../views/GiftCard/GiftCardImages.constant';
import RemoveLineItemButton from '../RemoveLineItemButton';
import GiftCardInformation from './GiftCardInformation';
import { getFiGrowthBook } from '../../lib/growthbook';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface GiftCardLineItemProps {
  id: CartItemID;
  productPriceInCents: number;
  giftCardDelivery: GiftCardDelivery;
  removeCartItem?: () => void;
  currencyFormatter: Intl.NumberFormat;
}

export default function GiftCardCartItem({
  productPriceInCents,
  giftCardDelivery,
  removeCartItem,
  currencyFormatter,
}: GiftCardLineItemProps) {
  const showEcomCartTest = getFiGrowthBook().getFeatureValue('ecom-cart-test', false);
  const { t } = useTranslation();
  return (
    <div className={styles.lineItem}>
      {removeCartItem && !showEcomCartTest && (
        <div className={styles.removeButtonRow}>
          <RemoveLineItemButton onClick={removeCartItem} />
        </div>
      )}
      <div className={styles.itemRow}>
        <div className={classNames(styles.lineItemImage, styles.giftCardImage)}>
          <Image image={GIFT_CARD_CART_IMAGE} desiredWidth={100} />
        </div>
        <div className={styles.lineItemBody}>
          <div className={styles.lineItemPriceRows}>
            <div className={styles.lineItemPriceRow}>
              <div className={styles.lineItemDetails}>
                <div className={styles.productName}>{t('fi_gift_card')}</div>
                <GiftCardInformation delivery={giftCardDelivery} />
              </div>

              <div className={styles.lineItemPrice}>
                {currencyFormatter.format(centsToDollarsNumber(productPriceInCents))}
              </div>
            </div>
          </div>
          {removeCartItem && showEcomCartTest && (
            <div className={styles.removeButton} onClick={removeCartItem}>
              {t('remove')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
